export const MODULE_DEF_DATA = {
  "tab-info": {
    key: Math.random().toString(16),
    type: "tab-info",
    version: "0.0.1",
    data: {
      title: "",
      tabList: [
        {
          key: Math.random().toString(16),
          isShowTopDesc: false,
          isShowBottomDesc: false,
          title: "Tab名称",
          icon: "",
          content: []
        }
      ]
    }
  },
  // 棕色尘埃图鉴定制模块
  "zs-tab-info": {
    key: Math.random().toString(16),
    type: "zs-tab-info",
    version: "0.0.1",
    data: {
      title: "",
      tabList: [
        {
          key: Math.random().toString(16),
          isShowSkill: false,
          isShowAttr: false,
          isShowTopDesc: false,
          isShowBottomDesc: false,
          title: "Tab名称",
          icon: "",
          content: [],
          attrList: [],
          skillData: {
            key: Math.random().toString(16),
            isShowIcon: true,
            isShowName: true,
            isShowDesc: true,
            isShowMore: true,
            icon: "",
            name: "",
            label: "",
            desc: "",
            moreInfo: "",
            moreBtn: "查看升级效果"
          }
        }
      ]
    }
  },
  "character-profile": {
    key: Math.random().toString(16),
    type: "character-profile",
    version: "0.0.1",
    data: {
      isShowImageList: true,
      isShowName: true,
      isShowAttrList: true,
      isShowDesc: true,
      title: "基础信息",
      name: "名称",
      descTitle: "个人简介",
      desc: "简介内容",
      attrList: [],
      imageSize: {
        width: "160px",
        height: "160px"
      },
      imagesList: []
    }
  },
  "character-info": {
    key: Math.random().toString(16),
    type: "character-info",
    version: "0.0.1",
    data: {
      title: "角色信息",
      infoList: [
        {
          key: Math.random().toString(16),
          title: "名称",
          content: "内容"
        }
      ]
    }
  },
  "fight-info": {
    key: Math.random().toString(16),
    type: "fight-info",
    version: "0.0.1",
    data: {
      title: "数据信息",
      label: "等级调整",
      levelList: [
        {
          level: 1,
          levelInfoList: [
            {
              key: Math.random().toString(16),
              title: "名称",
              content: "内容"
            }
          ]
        }
      ]
    }
  },
  "skill-info": {
    key: Math.random().toString(16),
    type: "skill-info",
    version: "0.0.1",
    data: {
      title: "角色技能",
      isShowTabs: false,
      tabs: [
        // {
        //   key: Math.random().toString(16),
        //   label: "标签页"
        // }
      ],
      skillList: [
        {
          key: Math.random().toString(16),
          isShowIcon: true,
          isShowName: true,
          isShowDesc: true,
          isShowMore: true,
          filterTabKey: null,
          icon: "",
          name: "",
          label: "",
          desc: "",
          moreInfo: "",
          moreBtn: "查看升级效果"
        }
      ]
    }
  },
  "weapon-info": {
    key: Math.random().toString(16),
    type: "weapon-info",
    version: "0.0.1",
    data: {
      isShowIcon: true,
      isShowLabel: true,
      isShowName: true,
      isShowDesc: true,
      isShowTable: true,
      isShowSkill: true,
      title: "专武详情",
      icon: "",
      label: "",
      name: "",
      desc: "",
      tableList: [
        {
          key: Math.random().toString(16),
          title: "表格标题",
          colStyle: [{ align: "left" }],
          head: [""],
          body: [[""]]
        }
      ],
      skillData: {
        key: Math.random().toString(16),
        isShowIcon: true,
        isShowName: true,
        isShowDesc: true,
        isShowMore: true,
        icon: "",
        name: "",
        label: "",
        desc: "",
        moreInfo: "",
        moreBtn: "查看升级效果"
      }
    }
  },
  "upgrade-info": {
    key: Math.random().toString(16),
    type: "upgrade-info",
    version: "0.0.1",
    data: {
      title: "突破材料",
      isShowTabs: false,
      tabs: [
        // {
        //   key: Math.random().toString(16),
        //   label: "标签页"
        // }
      ],
      upgradeList: [
        {
          key: Math.random().toString(16),
          isShowTitle: true,
          isShowContent: true,
          isShowOther: true,
          filterTabKey: null,
          title: "",
          content: [],
          other: []
        }
      ]
    }
  },
  "material-info": {
    key: Math.random().toString(16),
    type: "material-info",
    version: "0.0.1",
    data: {
      title: "喜爱礼物",
      list: [
        {
          title: "",
          content: []
        }
      ]
    }
  },
  "audio-info": {
    key: Math.random().toString(16),
    type: "audio-info",
    version: "0.0.1",
    data: {
      title: "台词语音",
      isShowTabs: false,
      tabs: [
        // {
        //   key: Math.random().toString(16),
        //   label: "标签页"
        // }
      ],
      list: [
        {
          key: Math.random().toString(16),
          isHideTitle: false,
          filterTabKey: null,
          title: "分组标题1",
          showLength: 2,
          content: [
            {
              key: Math.random().toString(16),
              audio: "",
              name: "",
              desc: ""
            }
          ]
        }
      ]
    }
  },
  "relation-info": {
    key: Math.random().toString(16),
    type: "relation-info",
    version: "0.0.1",
    data: {
      title: "相关人物",
      list: [
        {
          key: Math.random().toString(16),
          isShowTitle: true,
          isShowContent: true,
          isShowOther: false,
          title: "标题",
          content: [],
          other: []
        }
      ]
    }
  }
};
